<template>
  <b-sidebar
    id="sidebar-create-quote-agreement"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="quoteAgreementCreate">

          <!-- Period -->
          <b-form-group
            :label="$t('Period')"
            label-for="period"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Period')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="quoteAgreement.period"
                :reduce="(option) => option.id"
                :options="periods"
                :get-option-label="(option) => option.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Period -->
          <b-form-group
            :label="$t('Organization')"
            label-for="organization"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Organization')"
              rules="required"
            >
              <v-select
                id="organization"
                v-model="quoteAgreement.org"
                :reduce="(option) => option.id"
                :options="organizations"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- DSC -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Dc amount')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('Dc amount')"
              label-for="dsc"
            >
              <b-form-input
                id="dsc"
                v-model="quoteAgreement.dsc"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- PhD -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Phd amount')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('Phd amount')"
              label-for="phd"
            >
              <b-form-input
                id="phd"
                v-model="quoteAgreement.phd"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Target DSC -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Dc targeted amount')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('Dc targeted amount')"
              label-for="target_dsc"
            >
              <b-form-input
                id="target_dsc"
                v-model="quoteAgreement.target_dsc"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Target PhD -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Phd targeted amount')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('Phd targeted amount')"
              label-for="target_phd"
            >
              <b-form-input
                id="target_phd"
                v-model="quoteAgreement.target_phd"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Intern -->
          <validation-provider
            #default="{ errors }"
            :name="$t('Trainee amount')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('Trainee amount')"
              label-for="intern"
            >
              <b-form-input
                id="intern"
                v-model="quoteAgreement.intern"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              rules="required|file-size:10"
            >
              <b-form-file
                v-model="file"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
                @change="handleFile"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormInput, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    BFormFile,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      file: null,
      base64: null,
    }
  },
  computed: {
    quoteAgreement: {
      get() {
        return this.$store.state.quoteAgreement.quoteAgreement
      },
      set(data) {
        this.$store.commit('quoteAgreement/UPDATE', data)
      },
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
    organizations() {
      return this.$store.state.staticModule.organizationList
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$store.commit('quoteAgreement/FRESH')
      this.base64 = null
      this.file = null
      this.$refs.quoteAgreementCreate.reset()
      hide()
    },
    handleFile(e) {
      // eslint-disable-next-line prefer-destructuring
      this.base64 = e.target.files[0]
    },
    submit(hide) {
      this.$refs.quoteAgreementCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, { ...this.quoteAgreement, file: this.base64 }, 'quoteAgreement/create', () => {
            this.$emit('refetchData')
            this.$store.commit('quoteAgreement/FRESH')
          })
          hide()
        }
      })
    },
  },
}
</script>
